<div class="protocol-types-container">

  <div class="protocol-types-list" *ngIf="rows().length > 0; else empty">
    <div class="protocol-type-row" *ngFor="let row of rows(); let i = index">
      <div class="row-accent" [style.background-color]="row.protocolType.color || '#cccccc'"></div>
      <div class="row-main">
        <span class="type-shortcut" [style.color]="row.protocolType.color">{{ row.protocolType.shortcut }}</span>
        <span class="type-name">{{ row.protocolType.name }}</span>
      </div>
      <div class="row-toggle" [nbTooltip]="'Für Wartungsabschluss verwenden'" nbTooltipPlacement="left">
        <nb-toggle
          [checked]="row.allowForMaintenanceTimer"
          [disabled]="!isEditing()"
          (checkedChange)="toggleMaintenanceTimer(i, $event)">
          Für Wartung
        </nb-toggle>
      </div>
      <div class="row-actions" *ngIf="isEditing()">
        <button nbButton ghost size="small" status="danger" (click)="removeRow(i)" nbTooltip="Entfernen">
          <nb-icon icon="close-outline" pack="eva"></nb-icon>
        </button>
      </div>
    </div>
  </div>

  <ng-template #empty>
    <p class="empty-hint">Noch keine Protokolltypen zugewiesen.</p>
  </ng-template>

  <div class="add-row" *ngIf="isEditing()">
    <button
      nbButton
      ghost
      size="small"
      type="button"
      [nbPopover]="protocolTypePickerTemplate"
      [nbPopoverPlacement]="NbPosition.BOTTOM_START"
      [nbPopoverAdjustment]="NbAdjustment.COUNTERCLOCKWISE"
      #protocolTypePicker="nbPopover"
      (click)="loadAllProtocolTypes()">
      <nb-icon icon="plus-outline" pack="eva"></nb-icon>
      Protokolltyp hinzufügen
    </button>
  </div>

</div>

<ng-template #protocolTypePickerTemplate>
  <div class="protocol-type-picker">
    <div class="picker-empty" *ngIf="!availableTypes.length">
      <nb-icon icon="inbox-outline" pack="eva"></nb-icon>
      <span>Keine weiteren Protokolltypen verfügbar</span>
    </div>
    <div
      class="picker-type-item"
      *ngFor="let type of availableTypes"
      role="button"
      tabindex="0"
      (click)="selectProtocolType(type)"
      (keydown.enter)="selectProtocolType(type)"
      (keydown.space)="selectProtocolType(type); $event.preventDefault()">
      <div class="picker-accent" [style.background-color]="type.color || '#cccccc'"></div>
      <span class="picker-shortcut" [style.color]="type.color">{{ type.shortcut }}</span>
      <span class="picker-name">{{ type.name }}</span>
    </div>
  </div>
</ng-template>
